var gift = {
	selectors: { },

	init: function () {
		var self = this;

		jQuery( document ).on( 'click', '.gift-opener', function(e) { 
			e.preventDefault();

			jQuery( '.gift-part' ).toggleClass( 'gift-part--visible' );
		});
	},
};

export { gift };
